// extracted by mini-css-extract-plugin
export var typingIndicator = "_mo-0";